import { gql } from '@apollo/client';
import { FUNDER } from '../fragments';

export const GET_FUNDER = gql`
  query getFunder($id: ID!) {
    funder(where: { id: $id }) {
      ...funder
      logo
    }
  }
  ${FUNDER}
`;
